import type {AppendMessage} from '@assistant-ui/core';

import type {TurnPermissionsPatch} from '../client/WbAgentClient';

/**
 * readAgentConfigOverride pulls the per-turn agent config override the composer
 * stashed in the append's `runConfig.custom`, or undefined when absent.
 */
export function readAgentConfigOverride(
  message: AppendMessage
): string | undefined {
  const value = message.runConfig?.custom?.agentConfigOverride;
  return typeof value === 'string' && value !== '' ? value : undefined;
}

/**
 * readPermissions pulls the per-turn permissions patch the composer stashed in
 * the append's `runConfig.custom` (e.g. a granted network-access request), or
 * undefined when absent.
 */
export function readPermissions(
  message: AppendMessage
): TurnPermissionsPatch | undefined {
  const value = message.runConfig?.custom?.permissions;
  return value != null && typeof value === 'object'
    ? (value as TurnPermissionsPatch)
    : undefined;
}

/**
 * shouldBypassQueue reports whether the append opted out of queueing (sent
 * with `runConfig.custom.shouldBypassQueue`), so it should run immediately
 * instead of joining the thread's queue.
 */
export function shouldBypassQueue(message: AppendMessage): boolean {
  return message.runConfig?.custom?.shouldBypassQueue === true;
}
